function initializeVideoPlayButtonEventHandlers() {
  const playButtons = document.querySelectorAll(".rbsv4-ugc-carousel__video-play-button");
  if (playButtons.length === 0) {
    return;
  }

  playButtons.forEach((playButton) => playButton.addEventListener("click", playVideo));
}

function initializeProductATCEventHandlers() {
  const atcButtons = document.querySelectorAll('.rbsv4-ugc-carousel__item-product-card-button[type="submit"]');
  if (atcButtons.length === 0) {
    return;
  }

  atcButtons.forEach((atcButton) => atcButton.addEventListener("click", addToCart));
}

function playVideo(event) {
  const playButton = event?.target?.closest(".rbsv4-ugc-carousel__video-play-button");
  if (!playButton) {
    return;
  }

  const videoId = "#video-" + playButton.getAttribute("data-video-id");
  const video = document.querySelector(videoId);
  if (!video) {
    return;
  }

  const videoButtonOverlay = event?.target?.closest(".rbsv4-ugc-carousel__video-play-button-overlay");
  const videoOverlay = document.querySelector(`${videoId}.rbsv4-ugc-carousel__video-overlay`);
  videoButtonOverlay.style.display = "none";
  videoOverlay.style.display = "none";
  video.play();
}

async function addToCart(event) {
  event.stopPropagation();
  event.preventDefault();

  try {
    const addToCartForm = event?.target?.closest('form[action$="/cart/add"]');
    const rawFormData = new FormData(addToCartForm);
    let formData = {};

    // create formData properties
    for (const [key, value] of rawFormData) {
      const match = key.match(/properties\[(.+?)\]/);
      if (match) {
        if (formData["properties"] === undefined) {
          formData["properties"] = {};
        }

        const propertyKey = match?.[1];
        formData["properties"][propertyKey] = value;
      } else {
        formData[key] = value;
      }
    }

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    if (response.ok) {
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      this.closeBuyBoxCard();
    } else {
      throw new Error("Failed to add to cart");
    }
  } catch (error) {}
}

function initializeCarouselNavigation() {
  const container = document.querySelector(".rbsv4-ugc-carousel__container");
  const prevBtn = document.querySelector(".rbsv4-ugc-carousel__nav-btn--prev");
  const nextBtn = document.querySelector(".rbsv4-ugc-carousel__nav-btn--next");
  const dotsContainer = document.querySelector(".rbsv4-ugc-carousel__nav-dots");
  if (!container || !prevBtn || !nextBtn) return;

  let resizeTimer;

  function getPageSize() {
    return container.clientWidth;
  }

  function getMaxScroll() {
    return container.scrollWidth - container.clientWidth;
  }

  function getNumPages() {
    const maxScroll = getMaxScroll();
    if (maxScroll <= 0) return 1;
    return Math.ceil(maxScroll / getPageSize()) + 1;
  }

  function getCurrentPage() {
    const maxScroll = getMaxScroll();
    if (container.scrollLeft >= maxScroll - 1) return getNumPages() - 1;
    return Math.round(container.scrollLeft / getPageSize());
  }

  function buildDots() {
    if (!dotsContainer) return;
    dotsContainer.innerHTML = "";
    const numPages = getNumPages();
    for (let i = 0; i < numPages; i++) {
      const dot = document.createElement("button");
      dot.classList.add("rbsv4-ugc-carousel__nav-dot");
      dot.setAttribute("aria-label", `Go to page ${i + 1}`);
      dot.addEventListener("click", () => {
        const targetScroll = i === getNumPages() - 1 ? getMaxScroll() : i * getPageSize();
        container.scrollTo({ left: targetScroll, behavior: "smooth" });
      });
      dotsContainer.appendChild(dot);
    }
  }

  function updateButtons() {
    const atStart = container.scrollLeft <= 1;
    const atEnd = container.scrollLeft >= getMaxScroll() - 1;
    prevBtn.classList.toggle("active", !atStart);
    nextBtn.classList.toggle("active", !atEnd);
  }

  function updateDots() {
    if (!dotsContainer) return;
    const dots = dotsContainer.querySelectorAll(".rbsv4-ugc-carousel__nav-dot");
    const currentPage = getCurrentPage();
    dots.forEach((dot, i) => dot.classList.toggle("active", i === currentPage));
  }

  prevBtn.addEventListener("click", () => {
    container.scrollBy({ left: -getPageSize(), behavior: "smooth" });
  });

  nextBtn.addEventListener("click", () => {
    container.scrollBy({ left: getPageSize(), behavior: "smooth" });
  });

  container.addEventListener("scroll", () => {
    updateButtons();
    updateDots();
  }, { passive: true });

  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      buildDots();
      updateButtons();
      updateDots();
    }, 200);
  });

  buildDots();
  updateButtons();
  updateDots();
}

document.addEventListener("DOMContentLoaded", () => {
  initializeVideoPlayButtonEventHandlers();
  initializeProductATCEventHandlers();
  initializeCarouselNavigation();
});
